import { observable, runInAction } from 'mobx';
import {
  AddItemToCartDto,
  CartType,
  RemoveItemFromCartDto,
} from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';
import CartService from '../../../services/entities/cart-service';

export default class CartStore {
  private service: CartService;

  @observable
  cart: CartType = {} as CartType;

  constructor() {
    const {
      apiFactory: { cartService },
    } = getEnv();
    this.service = cartService;
  }

  async initCart() {
    const response = await this.service.getCart();
    runInAction(() => {
      this.cart = response;
    });
  }

  async addToCart(payload: AddItemToCartDto) {
    const response = await this.service.addToCart(payload);

    runInAction(() => {
      this.cart = response;
    });

    return response;
  }

  async removeFromCart(payload: RemoveItemFromCartDto) {
    const response = await this.service.removeFromCart(payload);
    runInAction(() => {
      this.cart = response;
    });
    return response;
  }
}
